import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "CloseBg",
  "use": "CloseBg-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"CloseBg\"><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(1 1)\"><circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#F3F3F3\" stroke=\"#000\" stroke-width=\"2\" /><path fill=\"#000\" d=\"M5.978 6.977l1.2-1.2 2.85 2.85 3-2.85 1.2 1.2-3 2.85 3 3-1.2 1.2-3-3-2.85 3-1.2-1.2 2.85-3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol